import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["type", "setAlert", "setPaymentMethods", "setPaymentMethodForm"],
    _excluded2 = ["id"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from "react";
import { CREDIT_CARD_REMOVAL_SUCCESS_ALERT, GENERIC_ERROR } from "../../../../consts";
import { useRemovePaymentMethodMutation } from "../../../../generated/graphql.jsx";
import { SavedCard } from "../../../pure/saved-card/SavedCard/SavedCard.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SavedCardContainer = function SavedCardContainer(_ref) {
  var type = _ref.type,
      setAlert = _ref.setAlert,
      setPaymentMethods = _ref.setPaymentMethods,
      setPaymentMethodForm = _ref.setPaymentMethodForm,
      savedCard = _objectWithoutProperties(_ref, _excluded);

  var _useRemovePaymentMeth = useRemovePaymentMethodMutation(),
      _useRemovePaymentMeth2 = _slicedToArray(_useRemovePaymentMeth, 1),
      removePaymentMethod = _useRemovePaymentMeth2[0];

  var handleSavedCardRemoval = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return removePaymentMethod({
                variables: {
                  paymentMethodId: id
                },
                onCompleted: function onCompleted(_ref3) {
                  var paymentMethods = _ref3.removePaymentMethod.paymentMethods;
                  paymentMethods.length === 0 && setPaymentMethodForm({
                    visible: true,
                    type: "CREDIT_CARD"
                  });
                  setAlert({
                    variant: "success",
                    message: CREDIT_CARD_REMOVAL_SUCCESS_ALERT
                  });
                  setPaymentMethods(paymentMethods);
                },
                onError: function onError() {
                  setAlert({
                    variant: "error",
                    message: GENERIC_ERROR
                  });
                }
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSavedCardRemoval(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var savedCardId = savedCard.id,
      savedCardProps = _objectWithoutProperties(savedCard, _excluded2);

  return ___EmotionJSX(SavedCard, _extends({}, savedCardProps, {
    id: savedCardId,
    onRemove: function onRemove() {
      return handleSavedCardRemoval(savedCardId);
    },
    onUpdate: function onUpdate() {
      return setPaymentMethodForm({
        visible: true,
        type: "CREDIT_CARD",
        paymentMethodId: savedCardId
      });
    }
  }));
};